// extracted by mini-css-extract-plugin
module.exports = {"buttonClass":"button-module--button-class--2sDzL","buttonPush":"button-module--button-push--3e2-i"};